import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { apiClient } from '@/services/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await apiClient.forgotPassword(email.trim());
      setSent(true);
    } catch {
      toast.error('Erro ao enviar email');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen grid place-items-center p-4">
      <div className="w-full max-w-sm space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Esqueci a senha</h1>
          <p className="mt-2 text-muted-foreground">Te enviaremos um link para criar uma nova senha.</p>
        </div>

        {sent ? (
          <div className="rounded-md border border-emerald-200 bg-emerald-50 p-4">
            <p className="text-emerald-900 text-sm">
              Se este email existir, você receberá as instruções em alguns minutos.
            </p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <Input type="email" placeholder="Seu email" required value={email} onChange={e => setEmail(e.target.value)} />
            <Button type="submit" className="w-full" loading={loading}>Enviar link</Button>
          </form>
        )}

        <Link to="/login" className="text-sm text-brand-600 hover:underline block text-center">
          ← Voltar pro login
        </Link>
      </div>
    </div>
  );
}
